import { MouseEvent } from 'react';
import { useAnalytics } from 'use-analytics';

export const useSocialLogin = () => {
  const { track } = useAnalytics();

  const handleSocialLogin = (
    event: MouseEvent<HTMLButtonElement>,
    provider: string,
    link: string,
  ): void => {
    event.preventDefault();
    track(
      `login_${provider}_click`,
      { event_category: 'User login', event_label: 'login_form' },
      () => {
        window.location.href = link;
      },
    );
  };

  return {
    handleSocialLogin,
  };
};
